// src/components/shipping/shipping-options/tab/shipping-options-tab.component.jsx

import { useState } from 'react';

import Button from '../../../reusable/button/button.component';
import ComponentModal from '../../../reusable/component-modal/component-modal.component';
import AddShippingOption from '../add/add-shipping-option.components';
import ShippingOptionsTable from '../../../reusable/tables/shipping-table/shipping-options-table.component';

import {
  MainContainer,
  ContentContainer
} from '../../../../styles/component.styles';

const ShippingOptionsTab = ({
  options = [],
  providers = [],
  types = [],
  reload = async () => {}
}) => {
  const [showAddOption, setShowAddOption] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const [sortKey, setSortKey] = useState('');
  const [sortDirection, setSortDirection] = useState('');

  return (
    <MainContainer>
      {/* Modal: Add Shipping Option */}
      <ComponentModal
        isOpen={showAddOption}
        onClose={() => setShowAddOption(false)}
        title="Add Shipping Option"
      >
        <AddShippingOption
          providers={providers}
          types={types}
        />
      </ComponentModal>

      {/* Add Button */}
      <ContentContainer margin={'40px 0'}>
        <Button onClick={() => setShowAddOption(true)}>Add Shipping Option</Button>
      </ContentContainer>

      {/* Shipping Options Table */}
      <ShippingOptionsTable
        options={options}
        getOptions={reload}
        sortKey={sortKey}
        setSortKey={setSortKey}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        reloadTable={reload}
        onRowClick={(option) => setSelectedOption(option)}
      />
    </MainContainer>
  );
};

export default ShippingOptionsTab;